import * as React from 'react';
import classNames from 'classnames';
import {Flex} from '../Flex';
import {Text} from '../Text';
import style from './avatar.scss';

export interface AvatarProps {
  imageSrc?: string | null;
  gravatarUrl?: string;
  fallback: string;
  className?: string;
  size?: 'large' | 'small';
}

export interface AvatarState {
  imageUrl: string;
  showFallback: boolean;
}

export class Avatar extends React.Component<AvatarProps, AvatarState> {
  // This is `any` and not `React.Ref<HTMLImageElement>` because their typing does not include the `complete` attribute
  image?: any;

  constructor(props) {
    super(props);

    this.state = {
      imageUrl: props.imageSrc || props.gravatarUrl || null,
      showFallback: !props.imageSrc || !props.gravatarUrl,
    };
  }

  handleImageError = () => {
    this.setState({showFallback: true});
  };

  componentDidMount() {
    // If image isn't loaded, let react onError handle it
    if (this.image && (!this.image.complete || this.image.naturalWidth > 0)) {
      return;
    }

    this.setState({showFallback: true});
  }

  setImageRef = (ref) => {
    this.image = ref;
  };

  render() {
    const {imageUrl, showFallback} = this.state;
    const {fallback, size = 'large', className} = this.props;

    if (showFallback || !imageUrl) {
      return (
        <Flex
          justifyContent="center"
          alignItems="center"
          className={classNames(style.circle, style.avatarFallback, style[size], className)}
        >
          <Text type={size === 'small' ? 'h5' : 'h3'} text={fallback} resetMargin />
        </Flex>
      );
    }

    return (
      <img
        ref={this.setImageRef}
        alt={fallback}
        className={classNames(style.circle, style.avatar, style[size], className)}
        srcSet={imageUrl}
        onError={this.handleImageError}
      />
    );
  }
}

export default Avatar;
